// extracted by mini-css-extract-plugin
export default {"alertContainer":"OP3faBOiC2"};